import { faBatteryBolt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chip, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { DeviceBatteryStatuses } from 'src/constants/ButtonQa';
import { resolveBatteryStatusForCommunityDisplay } from 'src/utils/deviceUtils';

interface LowBatteryDisplayProps {
    batteryLevel: number;
    displayAsChip?: boolean;
}

function LowBatteryDisplay(props: LowBatteryDisplayProps) {
    const { batteryLevel, displayAsChip = false } = props;

    const { palette } = useTheme();

    const batteryStatus = resolveBatteryStatusForCommunityDisplay(batteryLevel);
    const batteryIsLow = batteryStatus === DeviceBatteryStatuses.LowBattery;

    if (batteryIsLow) {
        if (displayAsChip) {
            return (
                <Chip
                    label="Replace Battery"
                    color="error"
                    icon={<FontAwesomeIcon icon={faBatteryBolt} />}
                    sx={{ maxWidth: 'fit-content' }}
                />
            );
        }

        return (
            <Stack direction="row" sx={{ gap: 0.5, alignItems: 'center' }}>
                <FontAwesomeIcon icon={faBatteryBolt} color={palette.error.main} />
                <Typography variant="subtitle1" sx={{ color: 'error.main' }}>
                    Replace Battery
                </Typography>
            </Stack>
        );
    }

    return null;
}

export default LowBatteryDisplay;
